<template>
  <div class="kudo-item" v-on="selectable ? { click: onClick } : {}">
    <div class="kudo-item-img">
      <div class="kudo-item-hex-shadow">
        <div :class="['kudo-item-hex', kudoCss]">
          <b-img ref="kudoimg" :src="kudo.icon" :alt="kudo.name" :class="{ 'kudo-item-grayed': grayed }" />
          <b-popover
            v-if="imgref"
            :target="imgref"
            placement="bottomright"
            triggers="hover focus"
            custom-class="kudo-item-tip"
            :delay="{ show: 200, hide: 50 }"
          >
            <template #title>
              <b-row>
                <b-col>
                  {{ kudo.name }}
                </b-col>
                <b-col cols="auto">
                  <span v-html="typeHtml" />
                </b-col>
              </b-row>
            </template>
            <h6 class="color-darkteal">Definition</h6>
            <p>{{kudo.description}}</p>
            <h6 class="color-darkteal">How to detect it</h6>
            <p>{{kudo.detection}}</p>
            <slot name="tooltip" v-bind="{ kudo }" />
          </b-popover>
        </div>
      </div>
      <b-badge v-if="count > 0" class="kudo-item-badge">{{count}}</b-badge>
    </div>
    <div class="kudo-item-name">
      {{kudo.name}}
    </div>
  </div>
</template>

<script>
import { KUDO_TYPE } from '@/helpers/types'

export default {
  name: 'KudoItem',

  props: {
    kudo: {
      type: Object,
      required: true
    },

    selectable: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Boolean,
      default: false
    },

    count: {
      type: Number,
      default: 0
    }
  },

  computed: {
    refImg() {
      return this.$refs.kudoimg
    },

    grayed() {
      return this.selectable ? !this.selected : this.count === 0
    },

    typeHtml() {
      switch (this.kudo.type) {
        case KUDO_TYPE.EXPERTISE: return '<span class="color-blue">Technical skills</span> (expertise)'
        case KUDO_TYPE.BEHAVIORS: return '<span class="color-darkteal">Soft skills</span> (behaviors)'
        default: return ''
      }
    },

    kudoCss() {
      if (this.count >= 30) return 'kudo-item-hex-gold'
      if (this.count >= 20) return 'kudo-item-hex-silver'
      if (this.count >= 10) return 'kudo-item-hex-bronze'
      return ''
    }
  },

  data() {
    return {
      imgref: undefined
    }
  },

  mounted() {
    this.imgref = this.$refs.kudoimg
  },

  methods: {
    onClick() {
      this.$emit('click', this.kudo.id)
    }
  }
}
</script>
